import React from 'react';
import BackgroundImage from 'assets/background.jpg';

export const useBackground = () => {
  React.useEffect(() => {
    document.body.style.backgroundImage = `url('${BackgroundImage}')`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'top center';
    document.body.style.backgroundAttachment = 'fixed';
  }, []);
};
